// extracted by mini-css-extract-plugin
module.exports = {"loanAmount":"wwI43","inputTextWrapper":"_34ZQG","documentText":"_1vGzM"};